<template>
  <section
    id="demographics"
    class="co-bg-striped"
  >
    <div class="co-container-sm px-4 py-20">
      <h2 class="co-heading-2">
        年齢や性別に関係なく
        <br>
        誰でもスキル習得できる
      </h2>
      <div class="flex flex-col gap-y-9 text-center md:flex-row md:gap-12">
        <div class="basis-full md:mb-0 md:basis-6/12">
          <img
            class="mb-3 w-full"
            src="~/assets/images/Te/TeCommon/Demographics/chart-one.svg"
            loading="lazy"
            style="height: 255px"
          >
          <div class="co-display-10 mb-2 font-bold">
            受講生の<span class="text-co-primary-500">約<span class="co-display-8 font-bold">60</span>%が<span class="co-display-8 font-bold">30</span>代以上</span>
          </div>
          <p class="mb-0 text-left">
            プログラミングのスキルは若いうちから学ばないと身につかないと思われがちですが、年齢関係なく学習を始めてスキル習得することができます。
          </p>
        </div>
        <div class="basis-full md:mb-0 md:basis-6/12">
          <img
            class="mb-3 w-full"
            src="~/assets/images/Te/TeCommon/Demographics/chart-two.svg"
            loading="lazy"
            style="height: 255px"
          >
          <div class="co-display-10 mb-2 font-bold">
            <span>受講生の</span>
            <span class="text-co-primary-500">
              <span class="co-display-8 font-bold">3</span>
              <span>人に</span>
              <span class="co-display-8 font-bold">1</span>
              <span>人以上が</span>
              <span class="co-display-8 font-bold">女性</span>
            </span>
          </div>
          <p class="mb-0 text-left">
            プログラミングを学ぶ女性が近年増加傾向。テックアカデミーでは、プログラミングのスキルを習得された受講生の3人に1人以上が女性です。
          </p>
        </div>
      </div>
      <div class="co-display-13 mb-0 mt-6 flex items-center justify-center text-gray-500">
        <div class="inline-block">
          <span class="mr-0 block sm:mr-4 sm:inline">※調査対象 2022年7月1日〜2023年6月30日</span>
          <span>※対象コース：全コース</span>
        </div>
      </div>
    </div>
  </section>
</template>
